<template>
  <div class="evaluation">
    <Card>
      <div class="session-content-block">
        <h4 class="session-content-block__title" style="color: var(--attendee-brand-color);">
          <c-button
            size="sm"
            theme="default"
            @click="$router.back()"
          >
            <i class="fa-regular fa-arrow-left" style="color: var(--attendee-text-primary-color);"></i>
          </c-button>
        </h4>
      </div>

      <evaluation-form
        :error-status="errorStatus"
        type="event"
        ref="evaluationForm"
        :is-fetching="isFetching"
        :show-indicator="showIndicator"
        :evaluation-questions="evaluationQuestions"
        @submit="send"
      />
    </Card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import common from "../../../helpers/common";
import eventFollowUpAPI from "../../../api/eventFollowUpAPI";
import Card from "../../../components/ui/cards/card";
import Notify from "../../../components/ui/Notify";
import EvaluationForm from "../../../components/evaluations/evaluations-form";

export default {
  components: {
    Card,
    Notify,
    EvaluationForm,
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      errorStatus: null,
      isFetching: false,
      showIndicator: false,
      evaluationQuestions: [],
    }
  },
  computed: {
    ...mapGetters('attendeeStore', ['isSingleSession']),
  },
  mounted() {
    common.setHeaderText('Event Follow Up');

    this.fetch();
  },
  methods: {
    fetch() {
      this.isFetching = true;
      this.errorStatus = null;

      eventFollowUpAPI.fetch(this.attendeeId)
        .then((res) => {
          let counter = 0;

          res.data?.data?.forEach(item => {
            item.evaluationQuestions.forEach(eq => {
              eq.elementNumber = counter;
              counter++;
            });
          });

          this.evaluationQuestions = res.data?.data;
        })
        .catch((error) => {
          this.errorStatus = error?.response?.status;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    send() {
      this.$refs.evaluationForm.$refs.form.validate().then(success => {
        if (!success) {
          this.scrollToFirstErrorField(this.$refs.evaluationForm);
          return;
        }

        this.showIndicator = true;

        let data = {};

        this.evaluationQuestions.forEach(evaluation => {
          for (let key in evaluation.evaluationQuestions) {
            if (evaluation.evaluationQuestions.hasOwnProperty(key)) {
              if (!data[evaluation.section]) {
                data[evaluation.section] = [];
              }

              // if type checkbox then send array of string
              if (evaluation.evaluationQuestions[key].answer_layout === 'checkbox') {
                const checkedItems = evaluation.evaluationQuestions[key].value
                  .filter(item => item.checked)
                  .map(item => item.name);

                data[evaluation.section].push({
                  id: evaluation.evaluationQuestions[key].id,
                  value: checkedItems
                });
              } else {
                data[evaluation.section].push({
                  id: evaluation.evaluationQuestions[key].id,
                  value: evaluation.evaluationQuestions[key].value,
                });
              }
            }
          }
        });

        data = {...data};

        eventFollowUpAPI.send(this.attendeeId, data)
          .then((res) => {
            this.$nextTick(() => {
              this.$refs.evaluationForm.$refs.form.reset();
            });

            //TODO: check if it's work
            this.$store.commit("agendaStore/updateAgendaButtons", { ...res.data?.data?.buttons });

            if (this.isSingleSession) {
              this.$router.push({name: 'Single Event'});
            } else {
              this.$router.push({name: 'My Certificate'});
            }
          })
          .catch((error) => {
            const errs = error?.response?.data?.errors;

            this.mapAndSetObserverErrors(this.$refs.evaluationForm?.$refs?.form, errs);
            this.scrollToFirstErrorField(this.$refs.evaluationForm);
          })
          .finally(() => {
            this.showIndicator = false;
          });
      });
    },

    scrollToFirstErrorField(ref) {
      this.$nextTick(() => {
        const formEl = ref?.$el;
        if (!formEl) return;

        // Find the first element with error
        const firstInvalidInput = formEl.querySelector(
          '.text-danger, .is-invalid, .has-error'
        );

        if (firstInvalidInput?.scrollIntoView) {
          firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },


    // Map server keys like "evaluation.22.value" to provider ids dynamically
    mapAndSetObserverErrors(observer, serverErrors) {
      if (!observer || !serverErrors) return;

      // observer.refs contains child ValidationProviders
      const providersObj = observer.refs || {};
      const providers = Array.isArray(providersObj) ? providersObj : Object.values(providersObj);

      const idErrorMap = {};

      providers.forEach((prov) => {
        // Find the inner input/select/textarea that has the name attribute
        const input = prov?.$el?.querySelector('[name]');
        const fieldName = input?.getAttribute?.('name');
        if (!fieldName) return;

        const messages = serverErrors[fieldName];
        if (!messages) return;

        // VeeValidate accepts a string or an array of strings
        idErrorMap[prov.id] = Array.isArray(messages) ? messages : [messages];
      });

      if (Object.keys(idErrorMap).length) {
        observer.setErrors(idErrorMap);
      }
    },
  }
}
</script>

<style scoped lang="scss">
.evaluation {
  margin-top: var(--attendee-gap-md);
}
</style>
